import Axios from 'axios'
import { bearer, token } from '../helpers'
//spelling sir
export const ApiService = {
    store(endpoint,object) {
        let session = JSON.parse(localStorage.getItem('user'));
        let location = {
            location: session.location.id,
            prefix: session.location.prefix,
        }
        const params = {...object,...location}
        return Axios.post(`/api/${endpoint}`, params, { headers: bearer() }).then(response => {
            return Promise.resolve(response)
        }).catch((error) => {
            return Promise.reject(error)
        })
    },
    async generate() {
        let session = JSON.parse(localStorage.getItem('user'));
        let location = {
            location: session.location.id,
            prefix: session.location.prefix,
        }
        const params = {...location}
        return await Axios.post(`/api/get-token`, params, { headers: bearer() }).then(response => {
            return Promise.resolve(response.data)
        }).catch((error) => {
            return Promise.reject(error)
        })
    },

    get(endpoint, params, config = {}) {
        let session = JSON.parse(localStorage.getItem('user'));
        let location = {
            location : session.location.id 
        }
        return Axios.get(`/api/${endpoint}`, { ...config, params: { ...token(), ...params, ...location} }).then(response => {
            return Promise.resolve(response)
        }).catch((error) => {
            if (!Axios.isCancel(error)) console.log(error)
            return Promise.reject(error)
        })
    },

    async update(endpoint, object) {
        let session = JSON.parse(localStorage.getItem('user'));
        let location = {
            location: session.location.id,
            prefix: session.location.prefix,
        }
        const params = { ...object, ...location }
        return await Axios.put(`/api/${endpoint}`, params, { headers: bearer() })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    },

    async delete(endpoint,params) {
        return await Axios.delete(`/api/${endpoint}`, {
            data: {
                tokens: params
            }, headers: bearer()
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    },
    async deleteRecord(endpoint,params) {

        let session = JSON.parse(localStorage.getItem('user'));
        let location = {
            location : session.location.id 
        }

        return await Axios.delete(`/api/${endpoint}`, {
            data: {
                ...params,
                ...location
            }, headers: bearer()
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    },

    async updateStatus(endpoint,obj) {
        return await Axios.put(`/api/${endpoint}`, obj, { headers: bearer() })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    },

}
